var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"190","height":"11","viewBox":"0 0 237 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 1.50391L235.517 4.9942L26.0342 9.39619","stroke":"#FF7A08","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }